/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const contentBoxStyle = {
  paper: {
    padding: "1.5rem",
    height: "100%",
    width: "100%",
  },
  container: {
    minHeight: "100%",
  },
  content: {
    paddingTop: "1.5rem",
  },
};

export default contentBoxStyle;
